import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

// ─── STATS ────────────────────────────────────────────────────────────────────

export const fetchFeedbackStats = async () => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}feedback/stats/`
    );
    return response.data;
  } catch (error) {
    console.error("fetchFeedbackStats error:", error);
    return null;
  }
};

// ─── LIST ─────────────────────────────────────────────────────────────────────

export const fetchFeedbacks = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.rating)     params.set("rating",     filters.rating);
    if (filters.issue_id)   params.set("issue",       filters.issue_id);
    if (filters.date_range) params.set("date_range",  filters.date_range);
    if (filters.search)     params.set("search",      filters.search);
    if (filters.page)       params.set("page",        filters.page);
    if (filters.page_size)  params.set("page_size",   filters.page_size);

    const response = await authenticatedAxios.get(
      `${baseurl}feedback/list/?${params.toString()}`
    );

    const result = response.data;
    // DRF paginated envelope: { count, next, previous, results }
    if (result?.results !== undefined) return result;
    // fallback if pagination is ever removed
    if (Array.isArray(result)) return { count: result.length, results: result };
    return { count: 0, results: [] };
  } catch (error) {
    console.error("fetchFeedbacks error:", error);
    return { count: 0, results: [] };
  }
};

// ─── STATUS UPDATE ────────────────────────────────────────────────────────────

export const updateFeedbackStatus = async (id, newStatus) => {
  try {
    const response = await authenticatedAxios.patch(
      `${baseurl}feedback/${id}/status/`,
      { status: newStatus }
    );
    return response.data;
  } catch (error) {
    console.error("updateFeedbackStatus error:", error);
    return null;
  }
};